import styled from 'styled-components';
export const FavoriteCandidatesContentContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  position: relative;
`;
export const FavoriteCandidatesContentContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;
